class EmbedPage {
    constructor(iframe, reloadButton) {
        if (iframe) {
            this.initializeIframe(iframe);
        }

        if (iframe && reloadButton) {
            this.addEventListenerToReloadButton(iframe, reloadButton);
        }
    }

    initializeIframe(iframe) {
        iFrameResize({ log: false }, iframe);
    }

    addEventListenerToReloadButton(iframe, reloadButton) {
        reloadButton.addEventListener('click', function () {
            iframe.src = iframe.src;
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const iframe = document.querySelector('.embed-page__iframe');
    const reloadButton = document.querySelector('#reload-btn');

    if (iframe || reloadButton) {
        new EmbedPage(iframe, reloadButton);
    }
});
